/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdataexportheading3Inputs */

const en_accountdataexportheading3 = /** @type {(inputs: Accountdataexportheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download my data`)
};

const pt_accountdataexportheading3 = /** @type {(inputs: Accountdataexportheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar os meus dados`)
};

/**
* | output |
* | --- |
* | "Download my data" |
*
* @param {Accountdataexportheading3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdataexportheading3 = /** @type {((inputs?: Accountdataexportheading3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdataexportheading3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdataexportheading3(inputs)
	return pt_accountdataexportheading3(inputs)
});
export { accountdataexportheading3 as "accountDataExportHeading" }